<template>
    <b-btn
        href="#"
        class="myButton"
        @click.prevent="$emit('click', id)"
        :title="alt"
        :disabled="disabled"
    >
        <b-row align-v="center">
            <b-col cols="auto" v-if="!!icon" class="text-center"
                ><i :class="icon" class="fa-3x"></i
            ></b-col>
            <b-col class="xs-exclude"><slot></slot></b-col>
        </b-row>
    </b-btn>
</template>
<script>
export default {
    props: {
        icon: {
            type: String,
        },
        id: {
            type: String,
            default: () => `icon-button-${parseInt(Math.random() * 1000000)}`,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        alt() {
            return this.$slots.default[0]?.text ?? 'Botón'
        },
    },
}
</script>
<style>
.myButton {
    width: 100%;
    box-shadow: inset 0px 1px 0px 0px #7a8eb9;
    background: linear-gradient(to bottom, #637aad 5%, #5972a7 100%);
    background-color: #637aad;
    border: 1px solid #314179;
    display: inline-block;
    cursor: pointer;
    color: #ffffff;
    font-family: Arial;
    font-size: 18px;
    font-weight: bold;
    padding: 25px 25px;
    text-decoration: none;
    border-radius: 6px;
}
.myButton:hover {
    background: linear-gradient(to bottom, #5972a7 5%, #637aad 100%);
    background-color: #5972a7;
    color: #ffffff;
    font-weight: bold;
}
.myButton:active {
    position: relative;
    top: 1px;
}

@media screen and (max-width: 480px) {
    .xs-exclude {
        display: none;
    }
}
</style>
